export const getDefaultValues = (details) => ({
  SubscribePackagePositionLable: details?.SubscribePackagePositionLable || '',
});
